import { render, staticRenderFns } from "./ModifiersSidebarV2.vue?vue&type=template&id=8b599a82&scoped=true"
import script from "./ModifiersSidebarV2.vue?vue&type=script&lang=js"
export * from "./ModifiersSidebarV2.vue?vue&type=script&lang=js"
import style0 from "./ModifiersSidebarV2.vue?vue&type=style&index=0&id=8b599a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b599a82",
  null
  
)

export default component.exports